import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatteryCharging = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M4.875 15.25c-1.05 0-1.574 0-1.98-.192a2 2 0 0 1-.953-.953c-.192-.406-.192-.93-.192-1.98v-4.25c0-1.05 0-1.574.192-1.98a2 2 0 0 1 .953-.953c.406-.192.93-.192 1.98-.192m8.25 10.5c1.05 0 1.574 0 1.98-.192a2 2 0 0 0 .953-.953c.192-.406.192-.93.192-1.98v-4.25c0-1.05 0-1.574-.192-1.98a2 2 0 0 0-.953-.953c-.406-.192-.93-.192-1.98-.192m5.125 4v2.5m-9.4.454h-3.6L9.6 3.75l-.39 4.545h3.54l-4.2 7.955.3-4.546Z"
	})]
});
const ForwardRef = forwardRef(SvgBatteryCharging);
export { ForwardRef as ReactComponent };
